// src/components/products/Categorys.jsx
import React from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'

const Categorys = () => {
  const { categorys } = useSelector((state) => state.home)

  if (!categorys.length) {
    return (
      <div className="w-full flex justify-center py-10 text-secondary">
        No categories found.
      </div>
    )
  }

  return (
    <div className="w-[95%] mx-auto py-10">
      {/* centered, underlined heading */}
      <div className="mb-8 flex justify-center">
        <h2
          className="text-2xl font-bold text-center"
          style={{
            color: 'var(--color-text-primary)',
            textDecoration: 'underline',
            textUnderlineOffset: '4px',
          }}
        >
          Categories
        </h2>
      </div>

      {/* single-row scroll tray */}
      <div className="flex gap-6 overflow-x-auto hide-scrollbar pb-4">
        {categorys.map((c, i) => (
          <Link
            key={i}
            to={`/shops?category=${c.name}`}
            className="flex flex-col items-center gap-2 min-w-[100px]"
          >
            {/* circular image */}
            <div
              className="
                w-24 h-24
                rounded-full
                overflow-hidden
                shadow-md
                sm:w-28 sm:h-28
                md:w-32 md:h-32
              "
            >
              <img
                src={c.image}
                alt={c.name}
                className="
                  w-full h-full object-cover
                  transition-transform duration-300 hover:scale-110
                "
              />
            </div>
            {/* label */}
            <h3
              className="text-center text-sm sm:text-base font-semibold uppercase"
              style={{ color: 'var(--color-text-primary)' }}
            >
              {c.name}
            </h3>
          </Link>
        ))}
      </div>
    </div>
  )
}

export default Categorys
